import { createSelector } from '@reduxjs/toolkit';

const getState = (state) => state.brokerDashboard;

export const dashboardDataSelector = createSelector(getState, (state) => state.dashboardData);
export const isLoadingDashboardDataSelector = createSelector(
  getState,
  (state) => state.isLoadingDashboardData,
);
